// NoFound.jsx
import React from "react";
import "./NoFound.css";
import { SearchX, ArrowLeft, Home } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import Navbar from "../../../components/navbar/Navbar";
import Footer from "../../../components/footer/Footer";
import SocialMediaPanel from "../../../components/common/social-media/SocialMediaPanel";

const NoFound = () => {
  const navigate = useNavigate();

  return (
    <>
    
 
    <div className="not-found-wrapper">
      <motion.div
        className="not-found-content"
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        <div className="not-found-icon-box">
          <SearchX className="not-found-main-icon" />
        </div>

        <h1 className="not-found-title">Oops! Page Not Found</h1>
        <p className="not-found-subtitle">
          We couldn't find the page you're looking for. It might have been moved,
          deleted, or never existed.
        </p>

        <div className="not-found-actions">
          <button
            className="not-found-btn not-found-btn-back"
            onClick={() => navigate(-1)}
          >
            <ArrowLeft className="not-found-btn-icon" /> Go Back
          </button>

          <button
            className="not-found-btn not-found-btn-home"
            onClick={() => navigate("/")}
          >
            <Home className="not-found-btn-icon" /> Go Home
          </button>
        </div>
      </motion.div>

      <motion.div
        className="not-found-bg-shape"
        initial={{ scale: 0 }}
        animate={{ scale: 1 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
      />
    </div>
    
    </>
  );
};

export default NoFound;
